// extracted by mini-css-extract-plugin
module.exports = {"itemsWrapper":"DesignRequestDetails_itemsWrapper__1SdQg"};